import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import isEmpty from 'lodash/isEmpty';
import moment from 'moment';
import { FormattedMessage } from 'react-intl';

import { ADGMTextField, ADGMDatePicker, ADGMImage } from 'aurora-components';
import messages from 'aurora-translations';
import styles from './AddBuyerModal/styles';

function BuyerFields(props) {
  const {
    classes,
    locale,
    formState,
    apiResponse,
    isResponsePerson,
    handleStateChange,
    handleDateChange,
    // handleSelect,
    buyerSelected,
  } = props;

  if (formState.userType === 'person' && isResponsePerson)
    return (
      <div className={classes.inputGridContainer}>
        <ADGMTextField
          name='firstName'
          type='text'
          label={<FormattedMessage {...messages.Name_lang} values={{ lang: 'English' }} />}
          placeholder='Name in English'
          dir='ltr'
          required
          style={{ order: 2 }}
          onChange={handleStateChange}
          value={apiResponse?.firstName || apiResponse?.nameEn || ''}
          disabled={!isEmpty(apiResponse?.firstName || apiResponse?.nameEn)}
          customClasses={{ field: !isEmpty(apiResponse?.firstName || apiResponse?.nameEn) && classes.calculatedField }}
        />
        <ADGMTextField
          name='firstArabicName'
          type='text'
          label={<FormattedMessage {...messages.Name_lang} values={{ lang: 'Arabic' }} />}
          placeholder='Name in Arabic'
          dir='rtl'
          required
          style={{ order: 3 }}
          onChange={handleStateChange}
          value={apiResponse?.firstArabicName || apiResponse.nameAr || ''}
          disabled={!isEmpty(apiResponse?.firstArabicName || apiResponse.nameAr)}
          customClasses={{
            field: !isEmpty(apiResponse?.firstArabicName || apiResponse.nameAr) && classes.calculatedField,
          }}
        />
        <ADGMTextField
          name='nationalityEn'
          type='text'
          label={<FormattedMessage {...messages.nationality} />}
          placeholder='Nationality'
          required
          style={{ order: 4 }}
          value={locale === 'ar' ? apiResponse?.nationalityAr || '' : apiResponse?.nationalityEn || ''}
          disabled
          customClasses={{ field: classes.calculatedField }}
        />

        {apiResponse?.birthDate ? (
          <ADGMTextField
            name='birthDate'
            label={<FormattedMessage {...messages.Date_of_birth_DD_MM_YYYY} />}
            placeholder='Date of birth'
            style={{ order: 5 }}
            value={(apiResponse?.birthDate && moment(apiResponse?.birthDate).format('DD/MM/YYYY')) || ''}
            disabled
            customClasses={{ field: classes.calculatedField }}
          />
        ) : (
          <div style={{ order: 5 }}>
            <ADGMDatePicker
              key='birthDate'
              date={formState.birthDate}
              onChange={date => handleDateChange('birthDate', date)}
              component={
                // eslint-disable-next-line react/jsx-wrap-multilines
                <ADGMTextField
                  value={formState.birthDate ? moment(formState.birthDate).format('DD/MM/YYYY') : ''}
                  id='birthDate'
                  name='birthDate'
                  placeholder='dd/mm/yyyy'
                  label={<FormattedMessage {...messages.Date_of_birth_DD_MM_YYYY} />}
                  required
                  autoComplete='off'
                  startAdornment={
                    <ADGMImage name='Calendar.svg' alt='calendar' className={classes.calendarTextfieldIcon} />
                  }
                />
              }
            />
          </div>
        )}

        {apiResponse?.passportIssueDate ? (
          <ADGMTextField
            name='passportIssueDate'
            type='text'
            label={<FormattedMessage {...messages.Passport_issue_date} />}
            placeholder='Passport issue date'
            required
            style={{ order: 8 }}
            value={
              (apiResponse?.passportIssueDate && moment(apiResponse?.passportIssueDate).format('DD/MM/YYYY')) || ''
            }
            disabled
            customClasses={{ field: classes.calculatedField }}
          />
        ) : (
          <div style={{ order: 8 }}>
            <ADGMDatePicker
              key='passportIssueDate'
              date={formState.passportIssueDate}
              onChange={date => handleDateChange('passportIssueDate', date)}
              component={
                // eslint-disable-next-line react/jsx-wrap-multilines
                <ADGMTextField
                  value={formState.passportIssueDate ? moment(formState.passportIssueDate).format('DD/MM/YYYY') : ''}
                  id='passportIssueDate'
                  name='passportIssueDate'
                  placeholder='dd/mm/yyyy'
                  label={<FormattedMessage {...messages.Passport_issue_date} />}
                  required
                  autoComplete='off'
                  startAdornment={
                    <ADGMImage name='Calendar.svg' alt='calendar' className={classes.calendarTextfieldIcon} />
                  }
                />
              }
            />
          </div>
        )}
        {apiResponse?.passportExpiryDate ? (
          <ADGMTextField
            name='passportExpiryDate'
            type='text'
            label={<FormattedMessage {...messages.Passport_expiry_date} />}
            placeholder='Passport expiry date'
            required
            style={{ order: 9 }}
            value={
              (apiResponse?.passportExpiryDate && moment(apiResponse?.passportExpiryDate).format('DD/MM/YYYY')) || ''
            }
            disabled
            customClasses={{ field: classes.calculatedField }}
          />
        ) : (
          <div style={{ order: 9 }}>
            <ADGMDatePicker
              key='passportExpiryDate'
              date={formState.passportExpiryDate}
              onChange={date => handleDateChange('passportExpiryDate', date)}
              component={
                // eslint-disable-next-line react/jsx-wrap-multilines
                <ADGMTextField
                  value={formState.passportExpiryDate ? moment(formState.passportExpiryDate).format('DD/MM/YYYY') : ''}
                  id='passportExpiryDate'
                  name='passportExpiryDate'
                  placeholder='dd/mm/yyyy'
                  label={<FormattedMessage {...messages.Passport_expiry_date} />}
                  required
                  autoComplete='off'
                  startAdornment={
                    <ADGMImage name='Calendar.svg' alt='calendar' className={classes.calendarTextfieldIcon} />
                  }
                />
              }
            />
          </div>
        )}
        <ADGMTextField
          name='phoneNumber'
          type='text'
          label={<FormattedMessage {...messages.phone_number} />}
          placeholder='Phone number'
          required
          style={{ order: 11 }}
          onChange={handleStateChange}
          value={apiResponse?.phoneNumber || apiResponse.phone || formState.phoneNumber || ''}
          disabled={!isEmpty(apiResponse?.mobileNo || apiResponse.phone)}
          customClasses={{
            field: !isEmpty(apiResponse?.phoneNumber || apiResponse.phone) && classes.calculatedField,
          }}
        />
        <ADGMTextField
          name='email'
          type='text'
          label={<FormattedMessage {...messages.Email} />}
          placeholder='Email'
          required
          style={{ order: 12 }}
          onChange={handleStateChange}
          value={apiResponse?.email || formState.email || ''}
          disabled={!isEmpty(apiResponse?.email)}
          customClasses={{ field: !isEmpty(apiResponse?.email) && classes.calculatedField }}
        />
      </div>
    );

  return (
    <div className={classes.inputGridContainer}>
      <ADGMTextField
        name='nameEN'
        type='text'
        label={<FormattedMessage {...messages.Name_English_bracket} />}
        dir='ltr'
        required
        onChange={handleStateChange}
        value={buyerSelected?.nameEN || ''}
        disabled
      />
      <ADGMTextField
        name='nameAR'
        type='text'
        label={<FormattedMessage {...messages.Name_Arabic_bracket} />}
        required
        onChange={handleStateChange}
        value={buyerSelected?.nameAR || ''}
        disabled
      />
      <ADGMTextField
        name='passportNumber'
        type='text'
        label={<FormattedMessage {...messages.Passport_number} />}
        required
        onChange={handleStateChange}
        value={buyerSelected?.passportNumber || ''}
        disabled
      />

      <ADGMTextField
        name='nationality'
        type='text'
        label={<FormattedMessage {...messages.Nationality} />}
        required
        onChange={handleStateChange}
        value={buyerSelected?.nationality || ''}
        disabled
      />

      <ADGMTextField
        name='email'
        type='text'
        label={<FormattedMessage {...messages.Email} />}
        required
        onChange={handleStateChange}
        value={buyerSelected?.email || ''}
        disabled
      />

      <ADGMTextField
        name='mobileNumber'
        type='text'
        label={<FormattedMessage {...messages.mobile} />}
        required
        onChange={handleStateChange}
        value={buyerSelected?.mobileNumber || ''}
        disabled
      />
    </div>
  );
}

BuyerFields.propTypes = {
  classes: PropTypes.object.isRequired,
  buyerSelected: PropTypes.object.isRequired,
  locale: PropTypes.string.isRequired,
  formState: PropTypes.object.isRequired,
  apiResponse: PropTypes.object.isRequired,
  isResponsePerson: PropTypes.bool.isRequired,
  handleStateChange: PropTypes.func.isRequired,
  handleDateChange: PropTypes.func.isRequired,
  handleSelect: PropTypes.func,
};

BuyerFields.defaultProps = {
  handleSelect: null,
};

export default withStyles(styles)(BuyerFields);
